var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['sts-root', { 'sts-root--ingame': _vm.$layout().ingame }]},[_c('router-view',{staticClass:"sts-web__content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }